// extracted by mini-css-extract-plugin
module.exports = {"modalInputText":"ConnectionModal_modalInputText__1PDqp","modalFormCheckbox":"ConnectionModal_modalFormCheckbox__3Og6u"};